import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {PiecejointeFormComponent} from './piecejointe-form/piecejointe-form.component';
import {SubSink} from '@Common/core/utils/subsink';
import {Bel} from "../../../services/bel/bel/bel.model";
import {PieceJointe} from "../../../services/piecejointe/piecejointe.model";


@Component({
  selector: 'app-upload-files',
  templateUrl: './upload-files.component.html',
  styleUrls: ['./upload-files.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class UploadFilesComponent implements OnInit, OnDestroy {
  @Input() bordereau: Bel;
  @Input() type: String;
  @Input() tooltip: String;

  @Output() pieceJointeEvent: EventEmitter<PieceJointe> = new EventEmitter();

  subsink = new SubSink();

  constructor(public dialog: MatDialog) {
  }

  ngOnInit() {
  }

  launchDownloader() {
    const dialog = this.dialog.open(PiecejointeFormComponent, {
      data: this.bordereau
    });
    dialog.updatePosition({top: '50px'});
    this.subsink.sink = dialog.afterClosed().subscribe(result => {
      this.pieceJointeEvent.emit(result);
    });
  }

  ngOnDestroy(): void {
    this.subsink.unsubscribe();
  }

}
